/* Longo Filters - Find Your MERV quiz. Renders into #lf-quiz-app. */
(function () {
  var PHONE = '(516) 442-0100';
  var LADDER = [8, 10, 11, 13];
  var BASE = { office: 11, retail: 11, apartment: 11, restaurant: 11, warehouse: 8, other: 10 };
  var CAP = { monthly: 13, quarterly: 13, biannual: 11, rarely: 8 };

  var QUESTIONS = [
    { key: 'building', q: 'What kind of space is it?', opts: [
      ['office', 'Office', 'General commercial space'],
      ['warehouse', 'Warehouse', 'Industrial or storage'],
      ['restaurant', 'Restaurant', 'Kitchen or food service'],
      ['retail', 'Retail store', 'Customer facing space'],
      ['apartment', 'Apartment complex', 'Multi unit residential'],
      ['other', 'Something else', 'Mixed use or not listed']
    ]},
    { key: 'air', q: 'What is in the air?', opts: [
      ['dust', 'Dust and debris', 'Construction, heavy foot traffic'],
      ['smoke', 'Cooking odors and smoke', 'Kitchens, grills, fryers'],
      ['chemicals', 'Chemical fumes', 'VOCs, solvents, paint, industrial'],
      ['none', 'Nothing specific', 'Normal everyday air']
    ]},
    { key: 'people', q: 'Who is in the space?', opts: [
      ['normal', 'Staff and visitors', 'Normal occupancy, nothing special'],
      ['allergies', 'People with allergies or asthma', 'Or a lot of foot traffic'],
      ['requirement', 'There is an air quality requirement', 'Lease, spec, medical or clean room'],
      ['equipment', 'Mostly equipment and storage', 'Few people in the space']
    ]},
    { key: 'interval', q: 'How often do filters actually get changed?', opts: [
      ['monthly', 'Monthly', 'On a tight schedule'],
      ['quarterly', 'Every 3 months', 'Standard commercial schedule'],
      ['biannual', 'Every 6 months', 'Twice a year'],
      ['rarely', 'Rarely', 'No set schedule, or when someone notices']
    ]}
  ];

  var FILTERS = {
    8: { name: 'MERV 8', url: '/products/pleated-merv-8',
      sub: 'The workhorse. Catches dust, lint and pollen without making your system work hard.',
      why: ['Captures dust, lint and pollen', 'Easiest on airflow and older equipment', 'Lowest cost per filter on volume orders'] },
    10: { name: 'MERV 10', url: '/products/pleated-merv-10',
      sub: 'A step up in filtration that still moves air freely. Good middle ground for most commercial spaces.',
      why: ['Adds mold spores and finer dust', 'Still easy on airflow', 'Noticeably cleaner air than MERV 8'] },
    11: { name: 'MERV 11', url: '/products/pleated-merv-11',
      sub: 'The one most commercial buildings land on. Strong filtration without choking the system.',
      why: ['Captures fine dust, dander and smoke particles', 'Best balance of air quality and airflow', 'What we sell most of for commercial work'] },
    13: { name: 'MERV 13', url: '/products/pleated-merv-13',
      sub: 'The highest filtration we stock in a pleated filter. For spaces where air quality is the point.',
      why: ['Captures bacteria, smoke and very fine particles', 'Meets most written air quality specs', 'Needs changing more often than lower grades'] }
  };

  var CARBON = { name: 'Odor Eliminator', url: '/products/odor-eliminating-carbon-filter' };

  var answers = {};
  var index = 0;
  var root;

  function step(merv, n) {
    var i = LADDER.indexOf(merv) + n;
    if (i < 0) i = 0;
    if (i > LADDER.length - 1) i = LADDER.length - 1;
    return LADDER[i];
  }

  function recommend() {
    var merv = BASE[answers.building] || 10;
    var carbon = false;
    if (answers.air === 'smoke') { carbon = true; if (merv < 11) merv = 11; }
    else if (answers.air === 'chemicals') { carbon = true; if (merv < 13) merv = 13; }
    if (answers.people === 'allergies') { merv = step(merv, 1); if (merv < 11) merv = 11; }
    else if (answers.people === 'requirement') { merv = 13; }
    else if (answers.people === 'equipment') { merv = step(merv, -1); if (merv > 10) merv = 10; }
    var target = merv;
    var final = Math.min(target, CAP[answers.interval]);
    return { merv: final, target: target, carbon: carbon, capped: final < target };
  }

  function serviceLine(merv) {
    if (answers.air === 'smoke') return 'Check these monthly. Kitchen grease loads a filter faster than anything else.';
    if (answers.air === 'dust') return 'Change every 1 to 3 months. Dust and construction debris fill a filter quickly.';
    if (merv === 13) return 'Change every 1 to 3 months. MERV 13 catches the most, so it loads the fastest.';
    if (merv === 11) return 'Change every 3 months in most buildings.';
    return 'Change every 3 to 6 months.';
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }

  function optionsHtml(q) {
    return q.opts.map(function (o) {
      var sel = answers[q.key] === o[0] ? ' is-selected' : '';
      return '<button type="button" class="lf-quiz__option' + sel + '" data-val="' + o[0] + '">' +
        esc(o[1]) + '<span class="lf-quiz__option-sub">' + esc(o[2]) + '</span></button>';
    }).join('');
  }

  function renderQuestion() {
    var q = QUESTIONS[index];
    var dots = QUESTIONS.map(function (x, i) {
      var c = i < index ? ' is-done' : (i === index ? ' is-active' : '');
      return '<div class="lf-quiz__progress-dot' + c + '"></div>';
    }).join('');
    var back = index > 0
      ? '<button type="button" id="lfq-back" class="lf-quiz__btn-outline" style="margin-top:20px;">Back</button>'
      : '';
    root.innerHTML =
      '<div class="lf-quiz__progress">' + dots + '</div>' +
      '<p style="font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#6b7280;margin:0 0 16px;">Question ' + (index + 1) + ' of ' + QUESTIONS.length + '</p>' +
      '<div class="lf-quiz__card">' +
        '<p class="lf-quiz__question">' + esc(q.q) + '</p>' +
        '<div class="lf-quiz__options">' + optionsHtml(q) + '</div>' + back +
      '</div>';
    root.querySelectorAll('.lf-quiz__option').forEach(function (b) {
      b.addEventListener('click', function () {
        answers[q.key] = b.dataset.val;
        b.classList.add('is-selected');
        setTimeout(function () {
          if (index < QUESTIONS.length - 1) { index++; renderQuestion(); }
          else { renderResult(); }
        }, 200);
      });
    });
    var backBtn = document.getElementById('lfq-back');
    if (backBtn) backBtn.addEventListener('click', function () { index--; renderQuestion(); });
  }

  function renderResult() {
    var r = recommend();
    var f = FILTERS[r.merv];
    var t = FILTERS[r.target];
    var box = 'margin:22px 0 0;padding:16px 18px;border-radius:12px;text-align:left;font-size:14px;line-height:1.55;';

    var service = '<div style="' + box + 'background:#f3f6ff;color:#10327A;"><strong>Service interval.</strong> ' + serviceLine(r.merv) + '</div>';

    var cap = '';
    if (r.capped) {
      cap = '<div style="' + box + 'background:#fff7e8;color:#8a5a00;border:1px solid #f0d9a8;">' +
        '<strong>Why not ' + t.name + '?</strong> On what you told us about filter changes, ' + t.name +
        ' would clog before it is swapped and your system would fight for air. Put the building on a 30, 60 or 90 day schedule and ' +
        t.name + ' becomes the right call. <a href="/pages/auto-delivery" style="color:#8a5a00;font-weight:700;">Set up auto delivery</a>.</div>';
    }

    var carbon = '';
    if (r.carbon) {
      carbon = '<div style="' + box + 'background:#eef7f0;color:#1d5b33;border:1px solid #cfe6d6;">' +
        '<strong>Add the ' + CARBON.name + '.</strong> Pleated filters catch particles, they do not catch smells. ' +
        'Activated carbon handles the odors and fumes, so run it alongside the ' + f.name + ' rather than instead of it. ' +
        '<a href="' + CARBON.url + '" style="color:#1d5b33;font-weight:700;">See the Odor Eliminator</a>.</div>';
    }

    root.innerHTML =
      '<div class="lf-quiz__card lf-quiz__result" style="display:block;">' +
        '<div style="text-align:center;">' +
          '<span class="lf-quiz__result-label">Your recommendation</span>' +
          '<p class="lf-quiz__result-title">We recommend ' + f.name + '</p>' +
          '<div class="lf-quiz__result-merv">' + f.name + '</div>' +
          '<p class="lf-quiz__result-sub">' + f.sub + '</p>' +
          '<ul class="lf-quiz__result-reasons">' + f.why.map(function (w) {
            return '<li class="lf-quiz__result-reason">' + w + '</li>';
          }).join('') + '</ul>' +
        '</div>' +
        service + cap + carbon +
        '<div class="lf-quiz__result-actions" style="margin-top:24px;">' +
          '<a href="' + f.url + '" class="lf-quiz__btn-primary">Shop ' + f.name + '</a>' +
          '<a href="tel:+15164420100" class="lf-quiz__btn-outline">Not sure? Call ' + PHONE + '</a>' +
          '<button type="button" id="lfq-restart" class="lf-quiz__btn-outline">Start over</button>' +
        '</div>' +
      '</div>';

    document.getElementById('lfq-restart').addEventListener('click', function () {
      answers = {}; index = 0; renderQuestion();
    });
    var sec = document.getElementById('lf-quiz-section');
    if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function init() {
    root = document.getElementById('lf-quiz-app');
    if (!root) return;
    renderQuestion();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
